import React from 'react'
import UpdateInfoSection from './UpdateInfoSection'
import ChangePasswordSection from './ChangePasswordSection'
import { UpdateOrganizationSection } from './UpdateOrganizationSection'

export default function Settings() {
  return (
    <div>
      {/* Settings forms */}
      <div className="divide-y divide-white/5">
        <UpdateInfoSection />
        <UpdateOrganizationSection />
        <ChangePasswordSection />
      </div>
    </div>
  )
}
